var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"wrap":""}},_vm._l((_vm.items),function(item,index){return _c('v-col',{key:index,attrs:{"cols":"12","md":"3"}},[_c('Cell',{attrs:{"item":item}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }